const PALETTE = ["#38BDF8", "#F472B6", "#A3E635", "#FB923C", "#C084FC", "#2DD4BF", "#FACC15", "#F87171"];

export function buildStops(entityId, events, pinByEntity) {
  const stops = [];
  [...events]
    .filter((e) => e.entity_ids?.includes(entityId) && pinByEntity[e.location_entity_id])
    .sort((a, b) => a.timestamp_int - b.timestamp_int)
    .forEach((e) => {
      const pin = pinByEntity[e.location_entity_id];
      const last = stops[stops.length - 1];
      if (last && last.pin.id === pin.id) last.events.push(e);
      else stops.push({ pin, t: e.timestamp_int, events: [e] });
    });
  return stops;
}

export function pathCandidates(entities, events, pins) {
  const pinByEntity = Object.fromEntries(pins.filter((p) => p.entity_id).map((p) => [p.entity_id, p]));
  return entities
    .filter((e) => e.category === "Character" || e.category === "Faction")
    .map((e) => ({ entity: e, stops: buildStops(e.id, events, pinByEntity) }))
    .filter((c) => c.stops.length)
    .sort((a, b) => a.entity.name.localeCompare(b.entity.name));
}

export const pathColor = (i) => PALETTE[i % PALETTE.length];

export const reachedIndex = (stops, t) => (t == null ? stops.length - 1 : stops.reduce((acc, s, i) => (s.t <= t ? i : acc), -1));
